import {Component} from 'react'
import Loader from 'react-loader-spinner'
import Cookie from 'js-cookie'
import {formatDistanceToNow} from 'date-fns'

import Sidebar from '../Sidebar'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'
import Header from '../Header'
import NonHomePageVideosContainer from '../NonHomePageVideosContainer'

import {
  LoaderContainer,
  RetryBtn,
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
} from '../Home/styledComponents'

import {NonHeaderContainer, TrendingBgContainer} from './styledComponents'

const apiStatus = {
  initial: 'INITIAL',
  inProgress: 'IN_PROGRESS',
  success: 'SUCCESSFUL',
  failed: 'FAILURE',
}

class TrendingRoute extends Component {
  state = {
    fetchStatus: apiStatus.initial,
    videosList: [],
  }

  componentDidMount() {
    this.setState({fetchStatus: apiStatus.inProgress})
    this.fetchVideos()
  }

  fetchVideos = async () => {
    const token = Cookie.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${token}`},
    }
    const response = await fetch(
      'https://apis.ccbp.in/videos/trending',
      options,
    )
    if (response.ok) {
      const data = await response.json()
      const updatedList = data.videos.map(eachItem => ({
        id: eachItem.id,
        title: eachItem.title,
        thumbnailUrl: eachItem.thumbnail_url,
        channel: {
          name: eachItem.channel.name,
          profileImgUrl: eachItem.channel.profile_image_url,
        },
        viewCount: eachItem.view_count,
        publishedDuration: formatDistanceToNow(new Date(eachItem.published_at)),
      }))
      this.setState({fetchStatus: apiStatus.success, videosList: updatedList})
    } else {
      this.setState({fetchStatus: apiStatus.failed})
    }
  }

  renderFailedView = darkMode => {
    const imgUrl = darkMode
      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
    return (
      <NonVideoContainer>
        <NoVideoImg src={imgUrl} alt="failure view" />
        <FailureHeading darkMode={darkMode}>
          Oops! Something Went Wrong
        </FailureHeading>
        <FailureContent darkMode={darkMode}>
          We are having some trouble to complete your request. Please try again.
        </FailureContent>
        <RetryBtn type="button" onClick={this.fetchVideos}>
          Retry
        </RetryBtn>
      </NonVideoContainer>
    )
  }

  renderLoadingView = darkMode => (
    <LoaderContainer data-testid="loader">
      <Loader
        type="ThreeDots"
        color={darkMode ? '#3b82f6' : '#000000'}
        height="50"
        width="50"
      />
    </LoaderContainer>
  )

  renderRespectiveContainer = darkMode => {
    const {fetchStatus, videosList} = this.state
    switch (fetchStatus) {
      case apiStatus.failed:
        return this.renderFailedView(darkMode)
      case apiStatus.inProgress:
        return this.renderLoadingView(darkMode)
      case apiStatus.success:
        return (
          <NonHomePageVideosContainer
            category="Trending"
            videosList={videosList}
          />
        )
      default:
        return null
    }
  }

  render() {
    return (
      <NxtWatchContext.Consumer>
        {value => {
          const {darkMode} = value
          return (
            <TrendingBgContainer>
              <Header />
              <NonHeaderContainer data-testid="trending" darkMode={darkMode}>
                <Sidebar />
                {this.renderRespectiveContainer(darkMode)}
              </NonHeaderContainer>
            </TrendingBgContainer>
          )
        }}
      </NxtWatchContext.Consumer>
    )
  }
}
export default TrendingRoute
